import type { UserDetailsRoleVM } from "@user-management-context/shared/domain/types/user-details-role-vm";

export const USER_TIMEZONE = "Europe/Paris";

interface UserCommon {
  id: string;
  name: string;
  lastName: string;
  email: string;
}

interface AdminUser extends UserCommon {
  isAdmin: true;
  roles: [];
}

interface BusinessUser extends UserCommon {
  isAdmin: false;
  roles: UserDetailsRoleVM[];
}

export type User = AdminUser | BusinessUser;
